import React from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { SignupForm } from '../components/auth/SignupForm'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/Card'

export function Signup() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const selectedPlan = searchParams.get('plan')

  const handleSuccess = () => {
    if (selectedPlan) {
      navigate(`/pricing?plan=${selectedPlan}`)
    } else {
      navigate('/pricing')
    }
  }

  const handleBack = () => {
    navigate('/')
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-throttle-navy-900 via-throttle-navy-500 to-throttle-navy-900 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full">
        <div className="mb-6 flex items-center justify-between">
          <button
            onClick={handleBack}
            className="flex items-center gap-2 text-white hover:text-throttle-cyan-400 transition-colors"
          >
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Back
          </button>
          <Link to="/" className="text-white hover:text-throttle-cyan-400 transition-colors">
            <div className="flex items-center gap-2">
              <svg className="w-8 h-8" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z"/>
                <path d="M6 10h2v2H6zm0 4h8v2H6zm10-4h2v6h-2z"/>
              </svg>
              <span className="font-bold text-lg">Social Pack</span>
            </div>
          </Link>
        </div>
        <Card>
          <CardHeader className="text-center">
            <CardTitle>Create Account</CardTitle>
            <CardDescription>
              Join us today! Create your account to get started.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <SignupForm onSuccess={handleSuccess} />
            <div className="mt-4 text-center">
              <p className="text-sm text-gray-600">
                Already have an account?{' '}
                <Link to="/login" className="text-throttle-cyan-500 hover:text-throttle-cyan-400 font-medium">
                  Sign in
                </Link>
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

export default Signup